import React , { useMemo, useState, useCallback }from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { currentClubData } from '../../store/selectors';
import { customParseFloat } from '../../helpers/array';
import configs from '../../config/config';
 
const fb = num => num > 0 ? `+${num}` : num

const sumWL = stats => customParseFloat([
  stats.poker ? stats.poker.wl : 0,
  stats.casino ? stats.casino.wl : 0,
  stats.liveCasino ? stats.liveCasino.wl : 0,
  stats.betting ? stats.betting.wl : 0,
].reduce((a, b) => a + b, 0));



const ClubStats = ({ alwaysExpanded, className }) => {
    const { t } = useTranslation();
    const clubData = useSelector(currentClubData);
    const stats = clubData ? clubData.totalWinLoss : null;
    const [expanded, setExpanded] = useState(false);
    const toggleGameInfo = useCallback(() => setExpanded(!expanded), [expanded, setExpanded]);

    console.log(stats);

    const classes = useMemo(() => {
      const c = ['gameInfo'];
      if (expanded || alwaysExpanded) c.push('expanded');
      if (className) c.push(className);
      return c.join(' ');
    }, [className, expanded, alwaysExpanded]);

    return (
        <div className={classes}>
            <div className={`gameInfoContent`}>
                {stats ? (<React.Fragment>
                    <div><span>{sumWL(stats)}</span><p>{t('overallWL')}</p></div>
                    <div><span>{stats.poker ? fb(stats.poker.wl) : 0}</span><p>{t('pokerWL')}</p></div>
                    <div><span>{stats.casino ? fb(stats.casino.wl) : 0}</span><p>{t('casinoWL')}</p></div>
                    <div><span>{stats.liveCasino ? fb(stats.liveCasino.wl) : 0}</span><p>{t('liveCasinoWL')}</p></div>
                    <div><span>{stats.poker ? fb(stats.poker.fee) : 0}</span><p>{t('pokerFee')}</p></div>
                    <div><span>{stats.betting ? fb(stats.betting.wl) : 0}</span><p>{t('sportsWL')}</p></div>
                </React.Fragment>) : false}
            </div>
            {!alwaysExpanded ? (<div className={`gameInfoExpander`} onClick={toggleGameInfo}>
                <i className={`fa fa-chevron-down`} />
            </div>) : false}
        </div>
    );
};

export default ClubStats;